export default __webpack_public_path__ + "static/media/PDF.8c67384d.svg";